import { useState } from "react";
import { PersonCard } from "@/components/people/PersonCard";
import { roleColor, slug } from "@/components/people/roles";

/** One role of a team — its people as cards, the long lists folded after the first few. */
export const RoleGroup = ({ group, scope, here, limit = 6, card }) => {
  const [all, setAll] = useState(false);
  const shown = all ? group.people : group.people.slice(0, limit);
  const id = `${scope}-${slug(group.role)}`;
  return (
    <div data-testid={`role-group-${id}`}>
      <div
        className="flex flex-wrap items-baseline justify-between gap-2 border-l-4 bg-muted px-3 py-2"
        style={{ borderColor: roleColor(group.role) }}
      >
        <span
          className="font-display text-xs font-bold uppercase tracking-widest"
          style={{ color: roleColor(group.role) }}
        >
          {group.role} · <span data-testid={`role-count-${id}`}>{group.people.length}</span>
        </span>
        <span className="text-[11px] text-muted-foreground">{group.help}</span>
      </div>
      <div className="mt-2 grid gap-2 sm:grid-cols-2 xl:grid-cols-3">
        {shown.map((p) => (
          <PersonCard key={p.key} p={p} here={here} {...card} />
        ))}
      </div>
      {group.people.length > limit && (
        <button
          type="button"
          data-testid={`role-more-${id}`}
          onClick={() => setAll((v) => !v)}
          className="mt-1 text-[11px] font-bold uppercase tracking-wider text-primary hover:underline"
        >
          {all ? "Show fewer" : `Show all ${group.people.length}`}
        </button>
      )}
    </div>
  );
};
